module.exports = __webpack_public_path__ + "img/green-check.49b308aa.svg";